<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_vi"></a><strong>I. MONGOL EMPIRE AT ITS HEIGHT</strong></p>
<p class="center1"><img alt="Image" height="383" src="images/f00vi-01.jpg" width="600"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?a72bdaba